import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cnames from 'classnames';
import SearchBoxLite from '@homeaway/react-searchbox-lite';
import { Experiment } from '../Experiment';
import { localizeUrl } from '@homeaway/localization-utils';

import './SearchBox.less';

class SearchBox extends Component {
  componentDidMount() {
    window.ha.userTiming.mark('primary.action.rendered');
  }

  onSubmit = ({ searchPath }) => {
    window.location.href = localizeUrl(searchPath, window.__SITE_CONTEXT__);
  }

  render() {
    const {
      locale,
      site,
      destination,
      checkIn,
      checkOut,
      guests,
      lbsId,
      domain,
      isMobile,
      labels,
      calendarLabels
    } = this.props;

    return (
      <Experiment name={'HA_PTA_LANDING_SearchboxBackgroundColor'} earlyReport>
        {value => (
          <SearchBoxLite
            className={cnames({ [`search__container--variant${value}`]: value >= 1 })}
            brand={site === 'vrbo' ? 'vrbo' : 'homeaway'}
            consolidatedSearchBox
            datePickerIcon
            guestPickerIcon
            expandedSearchBox
            showNextTooltip
            consolidateInputs={false}
            animatedCue
            showStabIcons
            smartDatePicker={false}
            submitFromGuestPicker={isMobile}
            isStickyMobile={isMobile}
            geoType={'point_of_interest'}
            onSubmit={this.onSubmit}
            stabTheme
            typeaheadProps={{
              hideSpinner: true,
              baseUrl: `https://${domain}`,
              environment: 'production',
              site,
              appPrefix: '/node/home/'
            }}
            {...{ domain, site, checkIn, checkOut, guests, lbsId, locale, destination, labels, calendarLabels }}
          />
        )}
      </Experiment>
    );
  }
}

SearchBox.propTypes = {
  locale: PropTypes.string.isRequired,
  site: PropTypes.string.isRequired,
  domain: PropTypes.string.isRequired,
  guests: PropTypes.shape({}),
  lbsId: PropTypes.string,
  destination: PropTypes.string,
  checkIn: PropTypes.string,
  checkOut: PropTypes.string,
  isMobile: PropTypes.bool.isRequired
};

export default SearchBox;
